import React from 'react';

/**
 * StatTile - shared compact metric card used on dashboards and detail pages.
 *
 * Props:
 *   label    string   uppercase caption
 *   value    node     primary big number (string or formatted react node)
 *   sub      node     optional small line beneath the value
 *   tone     string   active|disabled|alert|query|payload|tokens (colors the rail and icon bg)
 *   icon     node     optional 16-20px svg icon
 */
export default function StatTile({ label, value, sub, tone = '', icon }) {
  const toneClass = tone ? `billing-admin__stat-tile--${tone}` : '';
  return (
    <div className={`billing-admin__stat-tile ${toneClass}`}>
      <div style={{ minWidth: 0 }}>
        <p className="billing-admin__stat-label">{label}</p>
        <p className="billing-admin__stat-value">{value}</p>
        {sub != null && sub !== '' && (
          <p className="billing-admin__stat-sub">{sub}</p>
        )}
      </div>
      {icon && <div className="billing-admin__stat-icon">{icon}</div>}
    </div>
  );
}
